// extracted by mini-css-extract-plugin
export default {"logoutButton":"Logout_logoutButton__wBBHY","logoutLoader":"Logout_logoutLoader__wm2VP"};